"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParamsCountError = exports.ParamsErrorType = void 0;
const i18n_1 = require("../../exports/i18n");
/**
 * Params Error Type, used to identify the error type and error message
 */
var ParamsErrorType;
(function (ParamsErrorType) {
    ParamsErrorType[ParamsErrorType["NotEquals"] = 0] = "NotEquals";
    ParamsErrorType[ParamsErrorType["AtLeastCount"] = 1] = "AtLeastCount";
})(ParamsErrorType = exports.ParamsErrorType || (exports.ParamsErrorType = {}));
class ParamsCountError extends Error {
    constructor(type, paramsName, paramsCount) {
        // ideally, don't translation in `super` constructor
        // for compatibility of front-end i18n messages
        super(ParamsCountError.parseI18NMessage(type, paramsName, paramsCount));
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ParamsCountError.prototype);
        this._type = type;
        this._paramsName = paramsName;
        this._paramsCount = paramsCount;
    }
    static parseI18NMessage(type, paramsName, paramsCount) {
        let errorMessage;
        switch (type) {
            case ParamsErrorType.NotEquals:
                errorMessage = (0, i18n_1.t)(i18n_1.Strings.function_validate_params_count_at_least, {
                    name: paramsName,
                    count: paramsCount
                });
                break;
            case ParamsErrorType.AtLeastCount:
                errorMessage = (0, i18n_1.t)(i18n_1.Strings.function_validate_params_count_at_least, {
                    name: paramsName,
                    count: paramsCount,
                });
                break;
        }
        return errorMessage;
    }
    get type() {
        return this._type;
    }
    get paramsName() {
        return this._paramsName;
    }
    get paramsCount() {
        return this._paramsCount;
    }
}
exports.ParamsCountError = ParamsCountError;
//# sourceMappingURL=params_count.error.js.map